import React from 'react';
import {Icon} from 'semantic-ui-react';

import * as constants from './constants';
import EditableSelectbox from '../components/editableSelectbox';
import EditableCell from '../components/editableCell';

import {deleteCommercialUser, setEditableRowIndex} from '../actions/edit';

export const getColumns = (dispatch, {
  sessionInfo,
  dealerList,
  newRows,
  agenciesByDealer,
}) => {
  // username column index
  const uniqueFieldIndex = sessionInfo.isUserFromTDE ? 3 : 2;

  const dealersIdentificationByName = dealerList.reduce((pv, cv) => ({
    ...pv,
    [cv.name]: cv.identification,
  }), {});

  return [{
    'Header': () => <span className="header-title">CONCESIONARIO</span>,
    'accessor': 'concesionario',
    'title': 'CONCESIONARIO',
    'onlyTDE': true,
    'Cell': ({cell, row, column}) => {
      if (!newRows[row.original.id]) {
        return <>{cell.value}</>;
      }

      return <EditableSelectbox
        options={[
          {'label': 'Seleccione un concesionario...', 'value': ''},
          ...dealerList.map((dealer) => ({
            'label': dealer.name,
            'value': dealer.name,
          })),
        ]}
        value={cell.value}
        row={row}
        column={column}
        uniqueValue={row.original.id ?? row.cells[uniqueFieldIndex].value}
        width="12rem"
      />;
    },
  }, {
    'Header': () => <span className="header-title">AGENCIA</span>,
    'accessor': 'agencia',
    'title': 'AGENCIA',
    'Cell': ({cell, row, column}) => {
      const agencies = agenciesByDealer[
        !sessionInfo.isUserFromTDE ?
          sessionInfo.dealerId :
          dealersIdentificationByName[row.values.concesionario]
      ];

      if (!agencies) {
        return <>{cell.value}</>;
      }

      return <EditableSelectbox
        options={[
          {'label': 'Seleccione una agencia...', 'value': ''},
          ...Object.keys(agencies).map((key) => ({
            'label': `${agencies[key].code} - ${agencies[key].address}`,
            'value': agencies[key].address,
          })),
        ]}
        value={cell.value}
        row={row}
        column={column}
        uniqueValue={row.original.id ?? row.cells[uniqueFieldIndex].value}
        width="10rem"
      />;
    },
  }, {
    'Header': () => <span className="header-title">DEPARTAMENTO</span>,
    'accessor': 'departamento',
    'title': 'DEPARTAMENTO',
    'Cell': ({cell, row, column}) => {
      return <EditableSelectbox
        options={[
          {'label': 'Seleccione un departamento...', 'value': ''},
          ...Object.keys(constants.departments).map((key) => ({
            'label': constants.departments[key],
            'value': key,
          }))]}
        value={cell.value}
        row={row}
        column={column}
        uniqueValue={row.original.id ?? row.cells[uniqueFieldIndex].value}
        width='8rem'
      />;
    },
  }, {
    'Header': () => <span className="header-title">CORREO</span>,
    'accessor': 'correo',
    'title': 'CORREO',
    'Cell': ({cell, row, column}) => {
      return <EditableCell
        value={cell.value}
        row={row}
        column={column}
        uniqueValue={row.original.id ?? row.cells[uniqueFieldIndex].value}
      />;
    },
  }, {
    'Header': () => <span className="header-title">NOMBRES</span>,
    'accessor': 'nombres',
    'title': 'NOMBRES',
    'Cell': ({cell, row, column}) => {
      return <EditableCell
        value={cell.value}
        row={row}
        column={column}
        uniqueValue={row.original.id ?? row.cells[uniqueFieldIndex].value}
        width="6rem"
      />;
    },
  }, {
    'Header': () => <span className="header-title">APELLIDOS</span>,
    'accessor': 'apellidos',
    'title': 'APELLIDOS',
    'Cell': ({cell, row, column}) => {
      return <EditableCell
        value={cell.value}
        row={row}
        column={column}
        uniqueValue={row.original.id ?? row.cells[uniqueFieldIndex].value}
        width="6rem"
      />;
    },
  }, {
    'Header': () => <span className="header-title">CARGO</span>,
    'accessor': 'cargo',
    'title': 'CARGO',
    'Cell': ({cell, row, column}) => {
      return <EditableSelectbox
        options={[
          {'label': 'Seleccione un concesionario...', 'value': ''},
          ...Object.keys(constants.workPositions).map((key) => ({
            'label': constants.workPositions[key],
            'value': key,
          }))]}
        value={cell.value}
        row={row}
        column={column}
        uniqueValue={row.original.id ?? row.cells[uniqueFieldIndex].value}
        width='8rem'
      />;
    },
  }, {
    'Header': () => <span className="header-title">CIUDAD</span>,
    'accessor': 'ciudad',
    'title': 'CIUDAD',
  }, {
    'Header': () => <span className="header-title">TELEFONO</span>,
    'accessor': 'telefono',
    'title': 'TELEFONO',
    'Cell': ({cell, row, column}) => {
      return <EditableCell
        value={cell.value}
        row={row}
        column={column}
        uniqueValue={row.original.id ?? row.cells[uniqueFieldIndex].value}
        width='6rem'
      />;
    },
  }, {
    'Header': () => <span className="header-title">USUARIO</span>,
    'accessor': 'usuario',
    'title': 'USUARIO',
    'Cell': ({cell}) => {
      return <div title={cell.value} style={{'width': '10rem'}}>{cell.value}</div>;
    },
  }, {
    'Header': () => <span className="header-title">EXPORTADO</span>,
    'accessor': 'exportado',
    'title': 'EXPORTADO',
    'onlyTDE': true,
    'Filter': ({'column': {filterValue, setFilter}}) => {
      return <select
        onChange={(e) => setFilter(e.target.value ?? '')}
        value={filterValue}
      >
        <option value="">TODOS</option>
        <option value="SI">SI</option>
        <option value="NO">NO</option>
      </select>;
    },
  }, {
    'Header': () => <span className="header-title">ACCIONES</span>,
    'accessor': 'acciones',
    'Filter': () => null,
    'Cell': ({row}) => {
      const isActive = row.values.estado !== 'NO';
      return <div style={{'height': '2rem'}}>
        <Icon name='pencil' link size='large' color='black' onClick={() => {
          dispatch(setEditableRowIndex(row.index));
        }} />
        <Icon name='trash' link size='large' color={isActive ? 'red' : 'grey'} onClick={() => {
          if (isActive) {
            dispatch(deleteCommercialUser(row.original.id ?? row.cells[uniqueFieldIndex].value));
          }
        }} />
      </div>;
    },
  },
  ].filter((col) => (sessionInfo.isUserFromTDE || !col.onlyTDE));
};
